import { v4 as uuidv4 } from 'uuid';

export const getBrowserId = () => {
  let browserId = localStorage.getItem('browserId');
  if (!browserId) {
    const newUuid = uuidv4();
    localStorage.setItem('browserId', newUuid);
    browserId = newUuid;
  }
  return browserId;
};

export const isInternetExplorer = () => {
  return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
};

export const waitForVariable = (funcPath, interval = 100) =>
  new Promise(resolve => {
    const checkFunction = () => {
      const func = funcPath.split('.').reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : null), window);
      if (func) {
        resolve(func);
        return;
      }
      setTimeout(checkFunction, interval);
    };
    checkFunction();
  });
